import {useContext} from 'react';

import {Visibility, Close, PictureAsPdf} from '@mui/icons-material';
import {Box, Typography, IconButton, Grid, useTheme} from '@mui/material';


import {getDocumentListStyles} from './DocumentListStyles';
import {LanguageContext} from '../../contexts/LanguageContext/LanguageContext';
import {ApplicantDocuments} from '../../features/applicant/profile/types';
import {ALLOWED_FILE_TYPES} from '../../lib/constants';

interface Props {
  documents: ApplicantDocuments[];
  onDelete: (resourceId: string) => void;
}

export const DocumentList = ({documents, onDelete}: Props) => {
  const theme = useTheme();
  const currentLanguage = useContext(LanguageContext);
  const styles = getDocumentListStyles(theme);

  const getDocumentTypeLabel = (type: string) => {
    const documentType = ALLOWED_FILE_TYPES.find((fileType) => fileType.id === type);
    return documentType ? (
      <Typography variant='body2'>{documentType.label[currentLanguage]}</Typography>
    ) : (
      <Typography variant='body2'>Document</Typography>
    );
  };

  const handleView = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Grid container spacing={1} sx={styles.container}>
      {documents.map((document) => (
        <Grid item xs={12} sm={8} key={document.resourceId}>
          <Box sx={styles.documentItem}>
            <Box sx={styles.documentInfo}>
              <PictureAsPdf sx={styles.documentIcon} />
              {getDocumentTypeLabel(document.type)}
              <Typography sx={styles.documentText} variant='body2'>
                - {document.fileName}
              </Typography>
            </Box>

            <Box sx={styles.actionButtons}>
              <IconButton
                size='small'
                onClick={() => handleView(document.url)}
                sx={styles.viewButton}
                aria-label='View document'
              >
                <Visibility fontSize='small' />
              </IconButton>
              <IconButton
                size='small'
                onClick={() => onDelete(document.resourceId)}
                sx={styles.deleteButton}
                aria-label='Delete document'
              >
                <Close fontSize='small' />
              </IconButton>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
